import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { contactRequirementsByGroupTypes } from '@shared/constants/contact-requirements-by-group-types';
import { contactRoles } from '@shared/constants/contact-roles';
import { ContactRole } from '@shared/types/contact-role';
import { GroupType } from '@shared/types/group-type';

@Component({
  selector: 'app-contact-roles-container',
  templateUrl: './contact-roles-container.component.html',
  styleUrl: './contact-roles-container.component.scss',
  standalone: false,
})
export class ContactRolesContainerComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() groupType: GroupType;
  @Input() parentGroupType?: GroupType;
  @Input() groupEdit: boolean = false;
  @Input() formSubmitted: boolean = false;
  @Input() reviewMode?: boolean;
  @Input() contactFormGroups: FormGroup[] = [];
  @Input() contactsFormArray: FormArray;
  @Input() requiredRoleUnassigned: boolean = false;
  @Output() addEditContact = new EventEmitter<ContactRole>();
  @Output() updateAllCustomers = new EventEmitter();

  @ViewChild('rolesScrollBody') rolesScrollBody: ElementRef<HTMLDivElement>;

  canScrollRolesUp: boolean = false;
  canScrollRolesDown: boolean = false;
  showMoreRoles: boolean = false;
  visibleOptionalRoles: ContactRole[] = [];
  hiddenOptionalRoles: ContactRole[] = [];
  requiredContactRoles: ContactRole[] = [];
  optionalContactRoles: ContactRole[] = [];

  ngOnInit(): void {
    const contactRequirements = contactRequirementsByGroupTypes.find(
      (groupTypeData) => groupTypeData.groupType === this.groupType,
    )!;

    this.requiredContactRoles = contactRequirements.requiredContactRoles;

    this.optionalContactRoles = contactRoles
      .filter(
        (contactRole) =>
          !contactRequirements.requiredContactRoles.includes(contactRole.reference) &&
          !contactRequirements.excludedContactRoles.includes(contactRole.reference) &&
          !(
            this.parentGroupType === 'distributor' &&
            this.groupType == 'customer' &&
            contactRole.reference == 'partner'
          ),
      )
      .map((contactRole) => contactRole.reference);

    const limit = this.groupType === 'customer' && this.parentGroupType === 'distributor' ? 2 : 4;
    const visibleCount = Math.max(0, limit - this.requiredContactRoles.length);

    this.visibleOptionalRoles = this.optionalContactRoles.slice(0, visibleCount);
    this.hiddenOptionalRoles = this.optionalContactRoles.slice(visibleCount);

    this.showMoreRoles = this.hiddenOptionalRoles.some((role) =>
      this.contactFormGroups.some((form) => form.controls['contact_roles'].value.includes(role)),
    );
    this.updateRolesScrollState();
  }

  ngAfterViewInit(): void {
    this.updateRolesScrollState();
  }

  ngOnChanges(): void {
    this.updateRolesScrollState();
  }

  updateRolesScrollState(): void {
    const scroller = this.rolesScrollBody?.nativeElement;

    if (!scroller || window.innerWidth < 1024 || window.innerWidth >= 1536) {
      this.canScrollRolesUp = false;
      this.canScrollRolesDown = false;
      return;
    }

    this.canScrollRolesUp = scroller.scrollTop > 2;
    this.canScrollRolesDown = scroller.scrollTop < scroller.scrollHeight - scroller.clientHeight - 2;
  }

  scrollRoles(direction: 'up' | 'down'): void {
    const scroller = this.rolesScrollBody?.nativeElement;
    if (!scroller) return;

    const offset = Math.max(120, scroller.clientHeight * 0.6);
    scroller.scrollBy({ top: direction === 'down' ? offset : -offset, behavior: 'smooth' });
  }
}
